import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { updatePickupScheduleService } from "@WhiteCap/Store/Service/PickupWindowService";


export interface UpdatePickupScheduleApiParameter extends ApiParameter {
    orderId: string;
    pickUpTimeSlot: string;
    warehouseId: string;
    pickUpDate: string;
    lineIds: string;
    onError?: (error: string) => void;
    onSuccess?: () => void;
}
type HandlerType = CustomApiHandler<UpdatePickupScheduleApiParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/OrderStatus/PickupWindow/BeginUpdatingData",
    });
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await updatePickupScheduleService(props.apiParameter.orderId, props.apiParameter.pickUpTimeSlot, props.apiParameter.warehouseId, props.apiParameter.pickUpDate, props.apiParameter.lineIds);
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter.onSuccess();
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/OrderStatus/PickupWindow/UpdatingDataError",
            message: result.errorMessage,
        });
        return false;
    }
};

export const DispatchCompleteScheduleUpdate: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrderStatus/PickupWindow/CompleteUpdatingData",
        result: props.apiResult,
        orderId: props.apiParameter.orderId,
    });
};

export const chain = [PopulateApiParameter, MakeApiRequest, DispatchCompleteScheduleUpdate];

const updatePickupSchedule = createHandlerChainRunner(chain, "UpdatePickupSchedule");
export default updatePickupSchedule;
